Template.bands.helpers({
  bands: () => {
    return Bands.find({});
  }
});
